'use client';

import { createContext, PropsWithChildren, useContext, useMemo } from 'react';
import { useImmer } from 'use-immer';
import { AlertDialogProps } from 'components';

type OnOpenParams = Omit<AlertDialogProps, 'isOpen' | 'onClose'>;

interface AlertDialogContextData {
  alertDialogProps: AlertDialogProps | null;
  onOpenAlertDialog(data: OnOpenParams): void;
  onClose(): void;
}

const AlertDialogContext = createContext({} as AlertDialogContextData);

export const AlertDialogContextProvider = (props: PropsWithChildren) => {
  const { children } = props;

  const [alertDialogProps, setAlertDialogProps] =
    useImmer<AlertDialogProps | null>(null);

  const onClose = () => {
    setAlertDialogProps(null);
  };

  const onOpen = (data: OnOpenParams) => {
    setAlertDialogProps({
      ...data,
      isOpen: true,
      onClose,
    });
  };

  const value = useMemo(() => {
    return {
      alertDialogProps,
      onOpenAlertDialog: onOpen,
      onClose,
    };
  }, [alertDialogProps]);

  return (
    <AlertDialogContext.Provider value={value}>
      {children}
    </AlertDialogContext.Provider>
  );
};

export const useAlertDialog = () => useContext(AlertDialogContext);
